import { useState, useContext, useEffect } from "react"
import { useParams } from 'react-router-dom'
import { Field, useFormikContext } from "formik"
import { gql, useLazyQuery } from "@apollo/client"

import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import { InputSwitch } from "primereact/inputswitch"

import styles from "../../../styles/Form.module.css"

export default function ProgramIdGpra({ field, block, index }) {
  const { type } = useParams()
  const user = useContext(UserContext)
  const form = useContext(FormContext)
  const isEnterprise = type === 'enterprise'
  const formik = useFormikContext()
  const [visibility, setVisibility] = useState("none")
  const isDisabled = field.read_only || (form ? form.blocksSaved?.[block] : false)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()

  const IS_ACTIVE_GPRA = gql`
    query gpraEnableQuery($staff_id: ID!, $organization_id: ID!) {
      service: isMicroservicesActive(
        staff_id: $staff_id
        organization_id: $organization_id
        microservice_name: "GPRA"
      ) {
        organization_id
        microservices_id
        microservices_enabled
      }
    }
  `

  const CHECK_MICROSERVICES_STATUS = gql`
    query checkMicroservicesStatus($staff_id: ID!, $organization_ids: [ID!]!) {
      service: checkMicroservicesStatus(
        staff_id: $staff_id
        organization_ids: $organization_ids
        microservice_name: "GPRA"
      ) {
        data
      }
    }
  `

  const IS_AUTHORIZED = gql`
    query gpraAutorizedQuery($staff_id: ID!, $organization_id: ID!) {
      service: isMicroservicesAuthorized(
        staff_id: $staff_id
        enterprise_id: $organization_id
        microservice_name: "GPRA"
      ) {
        organization_id
        microservices_id
        microservices_authorized
      }
    }
  `

  const [gpraQuery] = useLazyQuery(isEnterprise ? IS_AUTHORIZED : IS_ACTIVE_GPRA)
  const [checkMicroserviceStatus] = useLazyQuery(CHECK_MICROSERVICES_STATUS)

  useEffect(() => {
    const getVisibility = async () => {
      let params = {
        staff_id: user.session.user.staff_id,
        organization_id: user.session.user.organization_id,
      }

      if (isEnterprise) {
        params.organization_id = user.session.user.enterprise_id
      }

      try {
        const { data } = await gpraQuery({
          variables: params,
          fetchPolicy: "no-cache",
        })

        const service = data?.service

        if (isEnterprise) {
          service?.microservices_authorized === "1" ? setVisibility("block") : setVisibility("none")
        } else {
          service?.microservices_enabled === "1" ? setVisibility("block") : setVisibility("none")
        }
      } catch (error) {
        console.error("Error fetching GPRA data:", error)
        formik.setFieldValue(field.field_name, false)
        setVisibility("none")
      }
    }

    getVisibility()
  }, [formik])

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: visibility,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && "*"}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => (
            <>
              <InputSwitch
                inputId={field.field_name}
                name={formikField.name}
                id={field.field_name}
                value={formikField.value}
                onChange={formikField.onChange}
                checked={formikField.value}
                disabled={isDisabled}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
